import { ProductsState } from './products.types';

/**
 *  Holding the state of the products.
 */
export const State: { products: ProductsState; } = {
    products: {
        additional: [],
        service: [],
        map: {
            additional: {},
            service: {},
        },
    },
};
